module.exports = __webpack_public_path__ + "img/title_telephoneOutline.e72ae2ed.svg";